import { useState } from 'react';
import { Outlet } from 'react-router';
import { Flex, Stack } from '@chakra-ui/react';

import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './utils/sizes';
import { STORAGE_KEYS } from '@/utils/storageKeys';

const Dashboard = () => {
  const [isCollapsed, setIsCollapsed] = useState(
    () => localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED) === 'true'
  );

  const handleToggle = () => {
    setIsCollapsed((c) => {
      localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(!c));
      return !c;
    });
    window.dispatchEvent(new Event('sidebar-toggle'));
  };

  return (
    <Flex flexDirection="column" minH="100vh">
      <Navbar hideFrom="md" />
      <Flex flex="1">
        <Sidebar
          hideBelow="md"
          isCollapsed={isCollapsed}
          onToggle={handleToggle}
        />
        <Stack
          px={{ base: 4, md: 6 }}
          py={{ base: 4, md: 6 }}
          flex="1"
          alignItems="stretch"
          marginLeft={{ base: 0, md: isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH }}
          transition="margin-left 0.2s ease"
        >
          <Outlet />
        </Stack>
      </Flex>
    </Flex>
  );
};

export default Dashboard;
